// 외부 바이어 도메인 감지 (auction.autodex.kr) — App.js 라우팅과 I18nProvider 의 전역 dir 스코프가 같은 판정을 쓴다.
// (신고 371: ERP 에서는 <html dir> 을 건드리지 않고 검차 셸 컨테이너에만 dir 을 준다.)
export function isBuyerDomain() {
  try { return /^auction\./i.test(window.location.host); } catch (e) { return false; }
}

export default isBuyerDomain;
